import { Box, Button, Dialog, DialogContent, IconButton, Typography } from '@mui/material'
import { FC, ReactNode, useState } from 'react'
import InfoIcon from '../../../assets/icons/i.svg?react'
import CloseIcon from '../../../sharedComponents/src/Dialogs/Icons/close'
import { secondaryFont } from '../../../sharedComponents/src/Theme/theme-v2'
import { DialogVariant, dialogTemplates } from './dialogTemplates'

interface ButtonDialogProps {
    variant: DialogVariant
    icon?: ReactNode
    buttonProps?: any
    children?: ReactNode
}

export const ButtonDialog: FC<ButtonDialogProps> = ({ variant, icon, buttonProps, children }) => {
    const [open, setOpen] = useState(false)
    const template = dialogTemplates[variant]

    const handleOpen = () => setOpen(true)
    const handleClose = () => setOpen(false)

    return (
        <>
            <Button
                onlyIcon
                variant="contained"
                color="primary"
                size="small"
                onClick={handleOpen}
                startIcon={icon || <InfoIcon style={{ transform: 'scale(1.4)' }} />}
                {...buttonProps}
            />

            <Dialog
                open={open}
                onClose={handleClose}
                sx={{
                    '& .MuiDialog-paper': {
                        border: '2px solid !important',
                        borderRadius: '8px',
                        borderColor: (theme) => ({
                            xs: `${theme.palette.primary.main} !important`,
                            md: `${theme.palette.primary.main} !important`,
                        }),
                        p: { xs: '48px 20px !important', md: '60px 80px !important' },
                        minHeight: { xs: 'unset !important', md: 'unset !important' },
                        height: { xs: 'unset !important', md: 'unset !important' },
                        justifyContent: 'center',
                        maxWidth: { xs: '400px', md: '660px' },
                    },
                }}
            >
                <IconButton
                    size="small"
                    onClick={handleClose}
                    sx={{ position: 'absolute', right: 16, top: 16, zIndex: 1 }}
                >
                    <CloseIcon />
                </IconButton>

                <DialogContent
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: { xs: 2, md: 5 },
                        px: 0,
                        py: 1,
                    }}
                >
                    {children || (
                        <>
                            <Typography
                                variant="h3"
                                fontFamily={secondaryFont}
                                fontWeight="bold"
                                textAlign="center"
                                textTransform="uppercase"
                                sx={{ fontSize: { xs: '24px', md: '40px' }, height: 'auto' }}
                            >
                                {template.title}
                            </Typography>
                            <Box component="img" src={template.image} alt={template.title} sx={{ width: '100%' }} />

                            <Typography textAlign="center" sx={{ fontSize: { xs: '14px', md: '18px' } }}>
                                {template.subtitle}
                            </Typography>
                        </>
                    )}
                </DialogContent>
            </Dialog>
        </>
    )
}
